import { Bookmark } from './Components/Bookmark';
import { ClickCounter } from './Components/ClickCounter';
import { Rating } from './Components/Rating';
import { RatingActivator } from './Components/RatingActivator';
import { VideoPopup } from './Components/VideoPopup';

(function ($) {
    if (typeof $ !== 'function') {
        return;
    }

    $(() => {
        new Bookmark();
        new ClickCounter();
        new Rating();
        new RatingActivator();
        new VideoPopup();
    });
})(window.jQuery);
